import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import modalModule from '../../dmFramework/dmJS/dmModalModule.store.js';
import permissionsModule from './permissionsModule.store.js';

import intermediaryEndpoints from '../views/intermediaries/intermediary.endpoints.js';
import systemsEndpoints from '../views/systems/systems.endpoints.js';
import institutionsEndpoints from '../views/institutions/institutions.endpoints.js';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        ModalModule: modalModule,
        PermissionsModule: permissionsModule
    },
    state: {
        localStoragePrefix: 'ita-admin-',
        intermediaryOptions: [],
        institutionsDegreeTypeOptions: [],
        institutionsFundingTypeOptions: [],
        stateOptions: [],
        userTypes: [],
        programOptions: [],
        intermediaryOptions: [],
        systemOptions: [],
        stateOptions: [],
        institutionOptions: [],
        roleOptions: [],
        selectedEntities: [],
    },
    mutations: {
        clearStore(state) {
            state.intermediaryOptions = [];
            state.institutionsDegreeTypeOptions = [];
            state.stateOptions = [];
            state.institutionsFundingTypeOptions = [];
            state.userTypes = [];
            state.programOptions = [];
            state.intermediaryOptions = [];
            state.systemOptions = [];
            state.stateOptions = [];
            state.institutionOptions = [];
            state.roleOptions = [];
            state.selectedEntities = [];
        },
        setDegreeTypeOptions(state, options) {
            state.institutionsDegreeTypeOptions = options;
        },
        setFundingTypeOptions(state, options) {
            state.institutionsFundingTypeOptions = options;
        },
        setProgramOptions(state, options) {
            state.programOptions = options;
        },
        setIntermediaryOptions(state, options) {
            let sortedOptions = options.sort((a, b) => {
                return a.Text.localeCompare(b.Text);
            })

            state.intermediaryOptions = sortedOptions;
        },
        setSystemOptions(state, options) {
            let sortedOptions = options.sort((a, b) => {
                return a.Text.localeCompare(b.Text);
            })

            state.systemOptions = sortedOptions;
        },
        setStateOptions(state, options) {
            state.stateOptions = options;
        },
        setInstitutionOptions(state, options) {
            let sortedOptions = options.sort((a, b) => {
                return a.Text.localeCompare(b.Text);
            })

            state.institutionOptions = sortedOptions;
        },
        setRoleOptions(state, options) {
            state.roleOptions = options;
        },
        setSelectedEntities(state, entities) {
            state.selectedEntities = entities;
        },
    },
    actions: {
        getIntermediaryOptions({commit}) {
            return intermediaryEndpoints.getAllDropdown()
                .then((response) => {
                    commit('setIntermediaryOptions', response);
                })
        },
        getProgramOptions({commit}) {
            return intermediaryEndpoints.getSponsorOptions()
                .then((response) => {
                    commit('setProgramOptions', response);
                })
        },
        getSystemOptions({commit}, intermediaryID) {
            return systemsEndpoints.getAllDropdown(intermediaryID)
                .then((response) => {
                    commit('setSystemOptions', response);
                })
        },
        getInstitutionOptions({commit}) {
            return institutionsEndpoints.getAllDropdown()
                .then((response) => {
                    commit('setInstitutionOptions', response);
                })
        },
        getStateOptions({commit}) {
            return institutionsEndpoints.getStates()
                .then((response) => {
                    commit('setStateOptions', response);
                })
        },
        getDegreeTypes({commit}) {
            return institutionsEndpoints.getDegreeTypes()
                .then((response) => {
                    commit('setDegreeTypeOptions', response);
                })
        },
        getFundingTypes({commit}) {
            return institutionsEndpoints.getFundingTypes()
                .then((response) => {
                    commit('setFundingTypeOptions', response);
                })
        }
    }
});

export default store;
